<template>
  <v-app id="app">
    <v-main>
      <Header />
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import Header from "./components/core/Header.vue";
export default {
  components: {
    Header,
  },
};
</script>
<style>
html,
body {
  overflow-x: hidden;
}

/* Brand primary — ensure Vuetify primary uses #e2bc89 even with other CSS */
.theme--light.v-application .primary,
.theme--dark.v-application .primary {
  background-color: #e2bc89 !important;
  border-color: #e2bc89 !important;
}
.theme--light.v-application .primary--text,
.theme--dark.v-application .primary--text {
  color: #e2bc89 !important;
  caret-color: #e2bc89 !important;
}
</style>
